import { FAQSection } from '@/components/organisms';

export function FAQPage() {
  return <FAQSection />;
}
